import axios from 'axios';

export const getWebEventStatus = async (url: string) => {
  return axios.get(url, { withCredentials: true });
};
